declare function CallTrack_function(page,RepName,ProductName,terms, usage500, usageObj1000, usage2000, zipcode, utility_name,enrollmentStatus,Email): void;
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
  Renderer2,
} from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { FormBuilder, FormGroup } from '@angular/forms';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { states } from '../../../../../assets/js/states';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from } from 'rxjs';
import { FileUploadService } from './file-upload.service';
const filesize = require('filesize');

@Component({
  selector: 'app-depositrequired',
  templateUrl: './depositrequired.component.html',
  styleUrls: ['./depositrequired.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class DepositRequiredComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  ssndepostList;
  isChecked = false;
  elem4;
  elem5;
  elem6;
  elem7;
  elem8;
  elem44;
  elem55;
  waiverreasonDropdown;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  ansinSSncheck2;
  phone_num;
  timer;
  autoPay = false;
  time = 1000;
  timeTrue = false;
  hideHome = false;
  url = environment.api_url;
  uploadedFilename = [];
  display = 'none';
  hasAnotherDropZoneOver = false;
  invalidFileSizeMsg = false;
  errorMsg = false;
  invalidFileMsg = false;
  vishome;
  user_bot;
  isDisable = false;
  modalRef: BsModalRef;
  accountNumber;
  productName;
  waiverReasons;
  reason;
  victimreason = false;
  seniorcitizen = false;
  paymenthistory = false;
  activehospitalemp = false;
  emailorfax = false;
  isuploadfile = false;
  isAmex = false;
  postResponseMessage;
  isClosed = true;
  fileSelected;
  waiverreasons = [
    'Select one',
    'I can provide 12 months of good payment history',
    'Senior Citizens in Good Standing',
    'Victim of Family Violence',
    'Medically Indigent',
    // "Active Hospital Employee",
    'Active Military Duty',
  ];
  providewaystocontact = ['Select one', 'Send via email or fax', 'Upload file'];
  // providewaystocontact = ['Select one', 'Send via email or fax'];

  addressId;
  Applyforadepositwaiver = false;
  Paythe$175deposit = false;
  activemilateryduty = false;
  activemedicalindigent = false;
  formattedCardNumber;
  dragOver: boolean;
  filelength;
  waiverreason;
  wayofcontact;
  statesArr;
  state = 'TX';
  street_address;
  city;
  apt;
  zipcode;
  carddetail;
  month;
  year;
  secuiritycode;
  cardName;
  accpetterms;
  formData: FormData;
  depositamount;
  label;
  updata;
  showmontherr = false;
  validCard = false;
  cvvValid = false;

  uploadForm: FormGroup;
  cityisNull = false;
  ccodeisNull = false;
  street_addressisNull = false;
  zipcodeisNull = false;
  dumbcardno;
  checkCardName = false;

  selectedFile: File = null;
  listofFiles = [];
  blankmontherr = false;
  blankyearerr = false;
  zipInvalidLength = false;
  first_name;
  last_name;
  email_address;
  language;
  dob;
  represnt;
  invoice;
  hearusOption;
  promo_code;
  ssn = '';
  license;
  orderDetails: any;
  public uploader: FileUploader = new FileUploader({
    url: this.url + '/fileupload',
    itemAlias: 'photo',
  });
  yearErrorFlag = false;
  errorMessage: string;
  enablesmshonest = true;
  enablesmschariot = true;
  userResponses;
  phone_num1 = '';
  maxLength: number;
  cardValue: any;
  cardType: string;
  cardNumberDisplay: any;
  isVisa: boolean;
  isMast: boolean;
  isDisc: boolean;
  formattedAutoCardNumber: any;
  autoPayment = false;
  automonth: string;
  autoyear: string;
  autosecuiritycode: string;
  autocardName: string;
  private monthList = [
    { Value: '01', Text: '01' },
    { Value: '02', Text: '02' },
    { Value: '03', Text: '03' },
    { Value: '04', Text: '04' },
    { Value: '05', Text: '05' },
    { Value: '06', Text: '06' },
    { Value: '07', Text: '07' },
    { Value: '08', Text: '08' },
    { Value: '09', Text: '09' },
    { Value: '10', Text: '10' },
    { Value: '11', Text: '11' },
    { Value: '12', Text: '12' },
  ];
  yearsList: any;
  private loadCardTypeDetails = {
    startWith3: this.validateAmexCardDetails.bind(this),
    startWith4: this.validateVisaCardDetails.bind(this),
    startWith5: this.validateMasterCardDetails.bind(this),
    startWith6: this.validateDiscoveryDetails.bind(this),
  };
  private loadCardNumberFormatting = {
    Visa: this.setAllCardNumberFormat.bind(this),
    Master: this.setAllCardNumberFormat.bind(this),
    Discover: this.setAllCardNumberFormat.bind(this),
    Amex: this.setAmexCardNumberFormat.bind(this),
  };
 
  constructor(
    private http: HttpClient,
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private modalService: BsModalService,
    private _scrollToService: ScrollToService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private fileUploadService: FileUploadService,
    private _renderer2: Renderer2,
  ) {
    this.statesArr = Object.keys(states);
    this.yearsList = this.residentialService.autoGenerateYears();
    if (this.residentialService.enrollmentPostResult !== undefined) {
      let depositAmount = this.residentialService.enrollmentPostResult;
      this.depositamount = depositAmount.DepositAmount;
      this.label = 'Pay the ' + depositAmount.DepositAmount + ' deposit';
    }
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.getProviderInfo();
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
    this.ssndepostList = {
      value4: false,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
    this.hideHome = true;
    var vishome = this.hideHome;
    sessionStorage.setItem('hideHome', JSON.stringify(vishome));
    this.deviceWidth = window.innerWidth;

    // var postresult = JSON.parse(this.residentialService.enrollmentPostResult);
    // if (postresult != undefined) {
    // }
    this.waiverReasons = this.waiverreasons;
    this.providewaystocontact = this.providewaystocontact;
    var postObj = JSON.parse(this.residentialService.enrollmentPostObject);
    this.street_address = postObj.BillingAddress;
    this.city = postObj.BillingCity;
    this.state = 'TX';
    this.apt = JSON.parse(sessionStorage.getItem('billingAddress')).apartment;
    this.zipcode = postObj.BillingZipcode;

    this.uploader.onBeforeUploadItem = (file) => {
      file.formData.push({ file: this.uploader.queue[0].file });
    };
    this.uploader.onAfterAddingFile = (file) => {
      this.invalidFileMsg = false;
      this.invalidFileSizeMsg = false;
      file.withCredentials = false;
      let index;
      if (this.uploader.queue.length > 0) {
        index = this.uploader.queue.length - 1;
      } else {
        index = 0;
      }

      for (let i = 0; i < this.uploader.queue.length; i++) {
        const formData: FormData = new FormData();
        formData.append('Image', this.uploader.queue[0].file.rawFile);
        this.updata = this.uploader.queue[0].file;
      }
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      this.uploadedFilename.push(response);
      this.residentialService.attachments.push(response);
    };
  }

  file: File = null; // Variable to store file to Upload

  setCardTextAutoPayBased() {
    // return this.autoPay4CE
    //   ? 'Card Number'
    //   : 'For Deposit Purposes - Enter Card Number*';

    return 'For Deposit Purposes - Enter Card Number*';
  }

  flipCardForSecurityCode(cvvValue, itemValue) {
    let visa;
    if (itemValue === 'auto') {
      visa = document.getElementById('jp-card-details');
    } else if (itemValue === 'noauto') {
      visa = document.getElementById('auto-card-details');
    }
    return cvvValue === undefined || cvvValue === ''
      ? visa.classList.remove('jp-card-flipped')
      : visa.classList.add('jp-card-flipped');
  }

  validateFullName(event) {
    return event === 'auto'
      ? this.cardName
        ? this.cardName
        : 'Full Name'
      : this.autocardName
      ? this.autocardName
      : 'Full Name';
  }

  validateCardDisplay(itemValue) {
    return itemValue === 'auto'
      ? this.formattedCardNumber
        ? this.formattedCardNumber
        : '**** **** **** ****'
      : this.formattedAutoCardNumber
      ? this.formattedAutoCardNumber
      : '**** **** **** ****';
  }

  validateAmexCardDetails(autoPay) {
    this.maxLength = 15;
    this.isAmex = true;
    const visa = !autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-amex');
    visa.classList.add('jp-card-identified');
  }

  validateVisaCardDetails(autoPay) {
    this.maxLength = 16;
    this.isVisa = true;
    const visa = !autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-visa');
    visa.classList.add('jp-card-identified');
  }

  validateMasterCardDetails(autoPay) {
    this.maxLength = 16;
    const visa = !autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-mastercard');
    visa.classList.add('jp-card-identified');
  }

  validateDiscoveryDetails(autoPay) {
    this.maxLength = 16;
    const visa = !autoPay
      ? document.getElementById('jp-card-details')
      : document.getElementById('auto-card-details');
    visa.classList.add('jp-card-discover');
    visa.classList.add('jp-card-identified');
  }


  setCardNumberFormatted(cardNumber) {
    var formattedCardNumber = cardNumber.replace(/[^\d]/g, '');
    formattedCardNumber = formattedCardNumber.substring(0, 16);
    // Split the card number is groups of 4
    var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
    if (cardNumberSections !== null) {
      formattedCardNumber = cardNumberSections.join(' ');
    }
    return formattedCardNumber;
  }

  setAllCardNumberFormat() {
    this.cardNumberDisplay = this.cardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
    this.formattedCardNumber = this.cardValue.replace(
      /\b(\d{4})(\d{4})(\d{4})(\d{4})\b/,
      '$1 $2 $3 $4'
    );
  }


  setAmexCardNumberFormat() {
    this.cardNumberDisplay = this.cardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
    this.formattedCardNumber = this.cardValue.replace(
      /\b(\d{4})(\d{6})(\d{5})\b/,
      '$1 $2 $3'
    );
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateCreditCardNumber() {
    this.dumbcardno = this.formattedCardNumber;
    if (this.isAmex) {
      this.formattedCardNumber = this.formattedCardNumber.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
      this.cardNumberDisplay = this.cardNumberDisplay.replace(
        /\d{4}(?= \d{3})/g,
        '****'
      );
    } else {
      this.formattedCardNumber = this.formattedCardNumber.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
      this.cardNumberDisplay = this.cardNumberDisplay.replace(
        /\d{4}(?= \d{4})/g,
        '****'
      );
    }
  }

  private loadServiceTypeObject = {
    NewService: this.assignServiceTypeValuesForNewService.bind(this),
    SwitchingProviders:
      this.assignServiceTypeValuesForStandardSwitch.bind(this),
  };
  handleCategoryBanner(files: FileList) {
    for (let j = 0; j < files.length; j++) {
      let data = new FormData();
      data.append('file', files[j].name);
    }
    const formData: FormData = new FormData();
    formData.append('Image', files[0], files[0].name);
    this.updata = files[0];
  }

  checkreasonExists(event) {
    this.reason = event;
    this.postResponseMessage = '';
    this.waiverreasonDropdown = document.getElementById('waiverreasonDropdown');
    

    if (_.contains(this.waiverreasonDropdown.classList, 'ng-select-focused')) {
      this.waiverreasonDropdown.classList.remove('ng-select-focused');
       }

    if (this.reason === 'Victim of Family Violence') {
      this.victimreason = true;
      this.seniorcitizen = false;
      this.paymenthistory = false;
      this.activehospitalemp = false;
      this.activemilateryduty = false;
      this.activemedicalindigent = false;
      this.wayofcontact = 'Select one';
    } else if (this.reason === 'Senior Citizens in Good Standing') {
      this.seniorcitizen = true;
      this.paymenthistory = false;
      this.activehospitalemp = false;
      this.victimreason = false;
      this.activemilateryduty = false;
      this.activemedicalindigent = false;
      this.wayofcontact = 'Select one';
    } else if (
      this.reason === 'I can provide 12 months of good payment history'
    ) {
      this.paymenthistory = true;
      this.activehospitalemp = false;
      this.seniorcitizen = false;
      this.victimreason = false;
      this.activemilateryduty = false;
      this.activemedicalindigent = false;
      this.wayofcontact = 'Select one';
    } else if (this.reason === 'Active Hospital Employee') {
      this.activehospitalemp = true;
      this.paymenthistory = false;
      this.seniorcitizen = false;
      this.victimreason = false;
      this.activemilateryduty = false;
      this.activemedicalindigent = false;
      this.wayofcontact = 'Select one';
    } else if (this.reason === 'Active Military Duty') {
      this.activemilateryduty = true;
      this.activehospitalemp = false;
      this.paymenthistory = false;
      this.seniorcitizen = false;
      this.victimreason = false;
      this.activemedicalindigent = false;
      this.wayofcontact = 'Select one';
    } else if (this.reason === 'Medically Indigent') {
      this.activemedicalindigent = true;
      this.activemilateryduty = false;
      this.activehospitalemp = false;
      this.paymenthistory = false;
      this.seniorcitizen = false;
      this.victimreason = false;
      this.wayofcontact = 'Select one';
    } else {
      this.activemedicalindigent = false;
      this.activemilateryduty = false;
      this.activehospitalemp = false;
      this.paymenthistory = false;
      this.seniorcitizen = false;
      this.victimreason = false;
      this.reason = 'Select one';
      this.user_bot = false;
      this.isDisable = true;
    }
  }

  providewaystocontactExists(event) {
    if (event === 'Send via email or fax') {
      this.emailorfax = true;
      this.isuploadfile = false;
      this.user_bot = true;
      this.isDisable = false;
      this.postResponseMessage = '';
    } else if (event === 'Upload file') {
      this.isuploadfile = true;
      this.emailorfax = false;
      this.user_bot = false;
      this.isDisable = true;
    } else {
      this.user_bot = false;
      this.isDisable = true;
      this.emailorfax = false;
      this.isuploadfile = false;
    }
  }

  fileOverAnother2(e: any): void {
    var dropArea = document.getElementById('drop-area');
    dropArea.addEventListener('dragover', (event) => {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    });

    dropArea.addEventListener('drop', (event) => {
      event.stopPropagation();
      event.preventDefault();
      const fileList = event.dataTransfer.files;
      this.selectedFile = fileList[0];
      if (this.listofFiles.length < 3 || this.listofFiles.length === 3) {
        this.listofFiles.push(this.selectedFile);
        this.listofFiles = _.uniq(this.listofFiles, function (fill) {
          return fill.name;
        });
      }
    });
  }

  fileOverAnothermobile(e: any): void {
    var dropAreamb = document.getElementById('drop-areamob');
    dropAreamb.addEventListener('dragover', (event) => {
      event.stopPropagation();
      event.preventDefault();
      // Style the drag-and-drop as a "copy file" operation.
      event.dataTransfer.dropEffect = 'copy';
    });

    dropAreamb.addEventListener('drop', (event) => {
      event.stopPropagation();
      event.preventDefault();
      const fileList = event.dataTransfer.files;
      this.selectedFile = fileList[0];

      if (this.listofFiles.length < 3 || this.listofFiles.length === 3) {
       

        if (this.file) {
         
          console.log(this.file);
          this.fileUploadService.upload(this.file).subscribe((event: any) => {
            this.listofFiles.push({ File: this.selectedFile, Path : event.path});
            this.isDisable = false;
            this.user_bot = true;
          });
        }

        this.listofFiles = _.uniq(this.listofFiles, function (fill) {
          return fill.name;
        });
      }
    });
  }

  onTempImageSelected(event) {
    this.fileSelected = event.target.value;
    this.file = event.target.files[0];
    //    const file = event.target.files[0]
    //   var reader = new FileReader();
    //   reader.readAsDataURL(event.target.files[0]);
    //   reader.onload = (event) => {
    //    this.fileSelected = (<FileReader>event.target).result;
    //  }

    if (
      event.target.files[0].type === 'image/png' ||
      event.target.files[0].type === 'image/bmp' ||
      event.target.files[0].type === 'image/jpeg' ||
      event.target.files[0].type === 'application/pdf'
    ) {
      if (event.target.files[0].size < 10000000) {
        const actualFileSize = filesize(event.target.files[0].size);
        this.selectedFile = <File>event.target.files[0];
        if (this.listofFiles.length < 3 || this.listofFiles.length === 3) {


          if (this.file) {
          
            console.log(this.file);
            this.fileUploadService.upload(this.file).subscribe((event: any) => {
              this.listofFiles.push({ File: this.selectedFile, Path : event.path});
              this.isDisable = false;
              this.user_bot = true;
            });
          }

         
        }
        this.invalidFileMsg = false;
      } else {
        this.invalidFileSizeMsg = true;
        this.listofFiles.pop();
      }
    } else {
      this.invalidFileMsg = true;
      this.listofFiles.pop();
    }
  }

  submitFiles() {
    if (this.uploader.queue.length > 0) {
      this.uploader.uploadAll();
      // AS file upload may take time setting the time out to send congrats email
      setTimeout(() => {
        const userResponses = {
          com_user_responce: this.residentialService.userResponse.userResponses,
        };
        const enrollbody = new HttpParams()
          .append('userResponses', JSON.stringify(userResponses))
          .append('enrollContactObj', localStorage.getItem('enrollContactObj'));
        this.http
          .post(this.url + '/commercial/congrats', enrollbody)
          .subscribe((notifyres) => {
            const result = notifyres;
          });
      }, 4000);
    }
  }

  onChangeRole(event) {
    
    this.isChecked = event.target.checked;
    if (this.deviceWidth < 768) {
      this.elem44 = document.getElementById('payfordepositt');
      this.elem55 = document.getElementById('applydepositwaiverr');
    } else {
      this.elem4 = document.getElementById('payfordeposit');
      this.elem5 = document.getElementById('applydepositwaiver');
    }
    if (this.isChecked === true) {
      this.user_bot = false;
      this.isDisable = true;
      this.waiverReasons = this.waiverreasons;
      this.providewaystocontact = this.providewaystocontact;
      this.statesArr = Object.keys(states);
      if (event.target.value === 'Paythe$175deposit') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: false,
          value7: false,
          value8: false,
        };
        this.ansinSSncheck = 'Paythe$175deposit';
        this.Paythe$175deposit = true;
        this.Applyforadepositwaiver = false;
        if (this.deviceWidth > 768) {
          // this.elem4.parentElement.classList.add('active-select');
          // if (_.contains(this.elem5.parentElement.classList, 'active-select')) {
          //   this.elem5.parentElement.classList.remove('active-select');
          // }
        }
        if (this.deviceWidth < 768) {
          // this.elem44.parentElement.classList.add('active-select');
          // if (
          //   _.contains(this.elem55.parentElement.classList, 'active-select')
          // ) {
          //   this.elem55.parentElement.classList.remove('active-select');
          // }
        }
        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.triggerScrollTo('addf_id');
          }
        }, this.time);
      } else if (event.target.value === 'Applyforadepositwaiver') {
        this.ssndepostList = {
          value4: false,
          value5: true,
          value6: false,
          value7: false,
          value8: false,
        };
        this.Paythe$175deposit = false;
        this.ansinSSncheck = 'Applyforadepositwaiver';
        this.Applyforadepositwaiver = true;
        this.waiverreason = 'Select one';
        this.wayofcontact = 'Select one';
        this.waiverReasons = this.waiverReasons;
        this.providewaystocontact = this.providewaystocontact;
        this.timeTrue = false;
        if (this.deviceWidth > 768) {
          // this.elem5.parentElement.classList.add('active-select');
          // if (_.contains(this.elem4.parentElement.classList, 'active-select')) {
          //   this.elem4.parentElement.classList.remove('active-select');
          // }
        }
        if (this.deviceWidth < 768) {
          // this.elem55.parentElement.classList.add('active-select');
          // if (
          //   _.contains(this.elem44.parentElement.classList, 'active-select')
          // ) {
          //   this.elem44.parentElement.classList.remove('active-select');
          // }
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('addf_id');
        }
      }
      if (!this.ref['destroyed']) {
        this.ref.detectChanges();
      }
    } else {
      this.Applyforadepositwaiver = false;
      this.victimreason = false;
      this.seniorcitizen = false;
      this.paymenthistory = false;
      this.activehospitalemp = false;
      this.activemilateryduty = false;
      this.activemedicalindigent = false;
      this.Paythe$175deposit = false;
      this.user_bot = false;
      this.isDisable = true;
      this.timeTrue = false;
      this.ssndepostList = {
        value4: false,
        value5: false,
        value6: false,
        value7: false,
        value8: false,
      };
      this.ansinSSncheck1 = '';
      this.ansinSSncheck2 = '';
      if (this.deviceWidth > 768) {
        this.elem4.parentElement.classList.remove('active-select');
        this.elem5.parentElement.classList.remove('active-select');
      }
      if (this.deviceWidth < 768) {
        this.elem55.parentElement.classList.remove('active-select');
        this.elem44.parentElement.classList.remove('active-select');
      }
    }
  }

  validateName(name) {
    if (name.target.val.match(/^[a-zA-Z]+$/)) {
      $(this).val(name.target.val.replace(/^[a-zA-Z]+$/, ''));
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  hideModal(value) {
    this.ssndepostList = {
      value4: true,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
    };
    this.modalRef.hide();
  }

  @HostListener('document:backbutton', ['$event'])
  onPopState(event) {
    alert('Start page');
  }

  ngOnInit() {
    this.loadScript();
    this.uploadForm = this.formBuilder.group({
      profile: [''],
    });
    this.waiverReasons = this.waiverreasons;
    this.providewaystocontact = this.providewaystocontact;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

 
  onChangeTxtCardNumber(event,autoPay) {
    this.postResponseMessage = '';
    const cardValue = event.target.value;
    this.cardValue = cardValue;
    this.dumbcardno = this.cardValue;
    //this.autoPay = false;
    var a = autoPay == true ? '' : 'auto';
    if (cardValue.length === 0) this.clearCardClassLists(a);
    this.cardType =
      cardValue.length > 0 ? this.getCardTypeValues(cardValue.charAt(0)) : '';
    if (cardValue.length > 0)
      this.loadCardTypeDetails[`startWith${cardValue.charAt(0)}`](autoPay);
    if (this.cardType) this.loadCardNumberFormatting[this.cardType]();
  }

  getCardTypeValues(itemValue) {
    return itemValue === '3'
      ? 'Amex'
      : itemValue === '4'
      ? 'Visa'
      : itemValue === '5'
      ? 'Master'
      : itemValue === '6'
      ? 'Discover'
      : '';
  }

  
  clearCardClassLists(itemValue) {
    const visa =
      itemValue === 'auto'
        ? document.getElementById('jp-card-details')
        : document.getElementById('auto-card-details');
    visa.classList.remove('jp-card-identified');
    visa.classList.contains('jp-card-visa')
      ? visa.classList.remove('jp-card-visa')
      : '';
    visa.classList.contains('jp-card-amex')
      ? visa.classList.remove('jp-card-amex')
      : '';
    visa.classList.contains('jp-card-mastercard')
      ? visa.classList.remove('jp-card-mastercard')
      : '';
    visa.classList.contains('jp-card-discover')
      ? visa.classList.remove('jp-card-discover')
      : '';
  }




  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
        // console.log('providerContact', this.providerContact);
      });
  }

  ngAfterViewInit(): void {
    this.ref.detach();
    setInterval(() => {
      if (!this.ref['destroyed']) {
        this.ref.detectChanges();
      }
    }, 0);

    this.waiverreasons = [
      'Select one',
      'I can provide 12 months of good payment history',
      'Senior Citizens in Good Standing',
      'Victim of Family Violence',
      'Medically Indigent',
      // 'Active Hospital Employee',
      'Active Military Duty',
    ];
    this.providewaystocontact = [
      'Select one',
      'Send via email or fax',
      'Upload file',
    ];
  }

  ngAfterContentChecked(): void {
    if (this.Paythe$175deposit === true) {
      if (
        this.formattedCardNumber != '' &&
        this.formattedCardNumber != undefined &&
        this.month != '' &&
        this.month != undefined &&
        this.year != '' &&
        this.year != undefined &&
        this.zipcode != '' &&
        this.zipcode != undefined &&
        this.street_address != undefined &&
        this.street_address != '' &&
        this.city != undefined &&
        this.city != '' &&
        this.secuiritycode != '' &&
        this.accpetterms === true &&
        this.secuiritycode != undefined &&
        this.cardName.length > 4 &&
        this.cardName != undefined
      ) {
        if (
          //this.showmontherr !== true &&
          this.yearErrorFlag !== true &&
          this.zipcode.length === 5 &&
          this.validCard != true //&&
          //!this.postResponseMessage
        ) {
          this.user_bot = true;
          this.isDisable = false;
        } else {
          // this.user_bot = false;
          // this.isDisable = true;
        }
      } else {
        this.user_bot = false;
        this.isDisable = true;
      }

      // const txtCardNumber = document.getElementById('txtCardNumber');
      // if (txtCardNumber) {
      //   if (this.formattedCardNumber != undefined && this.formattedCardNumber != '') {
      //     txtCardNumber.classList.remove('active-select');
      //     if (this.deviceWidth < 768) {
      //       txtCardNumber.classList.remove('active-select');
      //     }
      //   } else {
      //     txtCardNumber.classList.add('active-select');
      //     if (this.deviceWidth < 768) {
      //       txtCardNumber.classList.add('active-select');
      //     }
      //   }
      // }

      if (this.zipcode != '' && this.zipcode != undefined) {
        $('#zipcode').removeClass('active-select');
        this.zipcodeisNull = false;
      } else {
        $('#zipcode').addClass('active-select');
        this.zipcodeisNull = true;
      }

      if (
        this.month != '' &&
        this.month != undefined &&
        this.showmontherr != true
      ) {
        $('#cmonth').removeClass('active-select');
        if (this.deviceWidth < 768) {
          $('#ccmonth').removeClass('active-select');
        }
      } else {
        $('#cmonth').addClass('active-select');
        if (this.deviceWidth < 768) {
          $('#ccmonth').addClass('active-select');
        }
      }

      if (
        this.year != '' &&
        this.year != undefined &&
        this.showmontherr != true
      ) {
        $('#cyear').removeClass('active-select');
        if (this.deviceWidth < 768) {
          $('#ccyear').removeClass('active-select');
        }
      } else {
        $('#cyear').addClass('active-select');
        if (this.deviceWidth < 768) {
          $('#ccyear').addClass('active-select');
        }
      }

      const ccode = document.getElementById('ccode');
      if (ccode) {
        if (this.secuiritycode !== undefined && this.cvvValid != true) {
          this.ccodeisNull = false;
          ccode.classList.remove('active-select');
        } else if (
          (this.secuiritycode === '' || this.secuiritycode === undefined) &&
          this.cvvValid
        ) {
          this.ccodeisNull = true;
          ccode.classList.add('active-select');
        }
      }

      const cardname = document.getElementById('carddname');
      if (cardname) {
        if (this.cardName != '' && this.cardName != undefined) {
          cardname.classList.remove('active-select');
        } else if (this.cardName === '' && !this.checkCardName) {
          cardname.classList.add('active-select');
        }
      }

      if (this.city != '' && this.city != undefined) {
        $('#city').removeClass('active-select');
        this.cityisNull = false;
      } else {
        $('#city').addClass('active-select');
        this.cityisNull = true;
      }

      if (this.street_address != '' && this.street_address != undefined) {
        $('#street_address').removeClass('active-select');
        this.street_addressisNull = false;
      } else {
        $('#street_address').addClass('active-select');
        this.street_addressisNull = true;
      }



    }
  }

  openModal1() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled1() {
    this.display = 'none';
  }
  validateSecurityCode(itemValue) {
    return itemValue === 'auto'
      ? this.secuiritycode
        ? this.secuiritycode
        : '***'
      : this.autosecuiritycode
      ? this.autosecuiritycode
      : '***';
  }
  validateccName(event) {
    let value = event.target.value;
    if (value.length > 4) {
      this.checkCardName = false;
    } else {
      this.checkCardName = true;
    }
    this.showmontherr = false
  }

  // validateCreditCardNumber() {
  //   this.postResponseMessage = '';
  //   // Store the regexes as globals so they're cached and not re-parsed on every call:
  //   var visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  //   var mastPattern = /^(?:5[1-5][0-9]{14})$/;
  //   var amexPattern = /^(?:3[47][0-9]{13})$/;
  //   var discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

  //   var ccNum = this.formattedCardNumber.replace(/\s/g, '');

  //   var isVisa = visaPattern.test(ccNum) === true;
  //   var isMast = mastPattern.test(ccNum) === true;
  //   var isAmex = amexPattern.test(ccNum) === true;
  //   var isDisc = discPattern.test(ccNum) === true;

  //   var crdnum = document.getElementById('txtCardNumber');
  //   this.isAmex = isAmex;

  //   if (isVisa || isMast || isAmex || isDisc) {
  //     // at least one regex matches, so the card number is valid.
  //     this.validCard = false;
  //     this.dumbcardno = this.formattedCardNumber;
  //     if (isAmex) {
  //       this.formattedCardNumber = this.formattedCardNumber.replace(
  //         /\d{4}(?= \d{3})/g,
  //         '****'
  //       );
  //     } else {
  //       this.formattedCardNumber = this.formattedCardNumber.replace(
  //         /\d{4}(?= \d{4})/g,
  //         '****'
  //       );
  //     }

  //     if (isVisa) {
  //       // Visa-specific logic goes here
  //     } else if (isMast) {
  //       // Mastercard-specific logic goes here
  //     } else if (isAmex) {
  //       // AMEX-specific logic goes here
  //     } else if (isDisc) {
  //       // Discover-specific logic goes here
  //     }
  //   } else {
  //     this.validCard = true;
  //   }
  // }

  validate() {
    if (
      this.street_address === undefined ||
      this.street_address === null ||
      this.street_address === '' ||
      this.city === undefined ||
      this.city === '' ||
      this.city === null ||
      this.state === '' ||
      this.state === null ||
      this.state === undefined ||
      this.zipcode === null ||
      this.zipcode === '' ||
      this.zipcode === undefined
    ) {
      this.user_bot = false;
      this.isDisable = true;
    } else {
      if (this.zipcode.length < 5) {
        this.zipInvalidLength = true;
      } else {
        this.zipInvalidLength = false;
      }
      this.street_address = this.street_address;
      this.apt = this.apt;
      this.city = this.city;
      this.zipcode = this.zipcode;
    }
    this.showmontherr = false
  }

  mailMe(mail) {
    mail = document.createElement('a');
    mail.href =
      'mailto:customercare@mychariotenergy.com?subject=Question&body=Hi';
    mail.click();
  }

  validateMonth() {
    if (this.month) {
      var d = new Date();
      var n = d.getMonth() + 1;

      if (this.year === new Date().getFullYear().toString() && this.month < n) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else if (this.month > 12) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankmontherr = false;
        this.showmontherr = false;
        this.user_bot = true;
        this.isDisable = false;
      }
    } else if (this.month.length === 0) {
      this.blankmontherr = true;
      this.showmontherr = false;
    }
  }

  validateYear() {
    var d = new Date();
    var n = d.getMonth() + 1;
    if (this.year) {
      if (this.year < new Date().getFullYear().toString()) {
        this.yearErrorFlag = true;
        this.blankyearerr = false;
        this.user_bot = false;
        this.isDisable = true;
        this.year = '';
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.year === new Date().getFullYear().toString() &&
        this.month < n
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date occurs in the past. Enter a future date.';
      } else if (
        this.year >= new Date().getFullYear().toString() &&
        this.month > 12
      ) {
        this.showmontherr = true;
        this.user_bot = false;
        this.isDisable = true;
        this.errorMessage = 'Date is invalid. Enter a valid future date.';
      } else {
        this.blankyearerr = false;
        this.showmontherr = false;
        this.yearErrorFlag = false;
        this.year = this.year;

        this.user_bot = true;
        this.isDisable = false;

      }
    } else if (this.year.length === 0) {
      this.blankyearerr = true;
      this.showmontherr = false;
    }
  }
  flipCardFront(itemValue) {
    if (this.cardName !== undefined) {
      if (itemValue === 'auto') {
        const visa = document.getElementById('jp-card-details');
        visa.classList.remove('jp-card-flipped');
      } else if (itemValue === 'noauto') {
        const visa = document.getElementById('auto-card-details');
        visa.classList.remove('jp-card-flipped');
      }
    }
  }
  validatecvv(e) {
    let value = e.target.value;
    if (this.isAmex && value.length < 4) {
      this.cvvValid = true;
      $('#ccode').addClass('active-select');
    } else if (!this.isAmex && (value.length < 3 || value.length > 3)) {
      this.cvvValid = true;
      $('#ccode').addClass('active-select');
    } else {
      this.cvvValid = false;
      $('#ccode').removeClass('active-select');
    }
    this.user_bot = true;
    this.isDisable = false;
  }

  removeFile(removedfile) {
    const index = this.listofFiles.indexOf(removedfile);
    this.isClosed = false;
    this.postResponseMessage = '';
    //  document.getElementById('upload-msg-hidde').style.display = 'none';
    if (index > -1) {
    
      var file_json = {
        Path : removedfile.Path
      }
      this.fileUploadService.removefilefromupload(file_json).subscribe((event: any) => {
      
      });


      this.listofFiles.splice(index, 1);
    }

    if(this.listofFiles.length == 0)
    {
      this.isDisable = true;
      this.user_bot = false;
    }else
    {
      this.isDisable = false;
      this.user_bot = true;
    }
  }

  changeListener($event): void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.updata = myReader.result;
      this.updata = {
        filename: inputValue.files[0].name,
        filetype: 'image/jpeg',
        value: myReader.result.toString().split(',')[1],
      };
      // console.log(this.updata);
    };
    myReader.readAsDataURL(file);
  }

  SendApiDetsils() {
    this.openModal1();
    var postObj = JSON.parse(this.residentialService.enrollmentPostObject);
    var waivedReason,
      emailorfax,
      paydeposit,
      autopay,
      DepositZip,
      cardName,
      file = [];
    var isSendTextMessage = false;
    var isSendEmail = false;
    var SMSText = '';
    var DepositCardNumber,
      DepositCardExpirationMonth,
      DepositCardExpirationYear,
      DepositCVC,
      DepositBillingAddress,
      DepositUnit,
      DepositState,
      DepositZip,
      DepositCity;
    if (
      this.Applyforadepositwaiver &&
      !this.Paythe$175deposit &&
      this.emailorfax === true
    ) {
      waivedReason = this.reason;
      emailorfax = 'Yes';
      paydeposit = 'No';
      autopay = 'No';
      isSendTextMessage = true;
      SMSText =
        'Hey ' +
        postObj.FirstName +
        postObj.LastName +
        "! Thanks for choosing Honest Gorilla! 🙌 Friendly reminder that Chariot Energy can't process your service request until they receive your deposit waiver. Take a quick pic and email them to customercare@mychariotenergy.com.";
    } else if (
      this.Applyforadepositwaiver &&
      !this.Paythe$175deposit &&
      this.emailorfax === false &&
      this.isuploadfile === true
    ) {
      waivedReason = this.reason;
      emailorfax = 'No';
      paydeposit = 'No';
      autopay = 'No';

      file.push(this.updata ? this.updata : '');
    }

    if (this.Paythe$175deposit === true) {
      waivedReason = '';
      emailorfax = 'No';
      paydeposit = 'Yes';
      autopay = 'No';
      DepositCardNumber = this.dumbcardno.replace(/\s/g, '');
      var months = {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December',
      };
      if (this.month.length === 1) {
        this.month = '0' + this.month;
      }
      var selectedMonthName = months[this.month];

      DepositCardExpirationMonth = selectedMonthName ? selectedMonthName : '';
      DepositCardExpirationYear = this.year;
      DepositCVC = this.secuiritycode;
      cardName = this.cardName;

      DepositBillingAddress = this.street_address;
      DepositUnit = this.apt;
      DepositState = 'TX';
      DepositCity = this.city;
      DepositZip = this.zipcode;
    }

    var postObject = {
      Zip: postObj.Zip,
      PromoCode: sessionStorage.getItem('Promocode')
        ? sessionStorage.getItem('Promocode') === 'TAP'
          ? 'TAP'
          : 'HONESTGORILLA'
        : 'HONESTGORILLA',
      UtilityName: postObj.UtilityName,
      CustomerTypeID: '1',
      ProductID: postObj.ProductID,
      FirstName: postObj.FirstName,
      LastName: postObj.LastName,
      PhoneNumber: postObj.PhoneNumber,
      SecondaryPhoneNumber: '',
      EmailAddress: postObj.EmailAddress,
      BillDeliverMethodID: postObj.BillDeliverMethodID,
      Howdidyouhear: '',
      HowdidyouhearDes: '',
      languagePreference: postObj.languagePreference,
      IsSMS: 'Yes',
      IsPromoInterested: 'Yes',
      SSN: postObj.SSN,
      DriversLicence: '',
      DriversLicenceState: '',
      ByPassCreditCheck: 'No',
      // DOB: postObj.DOB,
      DOB: this.residentialService.setDateValueForChariot(postObj.DOB),
      ESIID: postObj.ESIID,
      MemberId: '',
      ServiceStartDate: postObj.ServiceStartDate,
      ServiceType: postObj.ServiceType,
      IsAccountHolder: postObj.IsAccountHolder,
      AuthorizedPhoneNumber: postObj.AuthorizedPhoneNumber,
      AuthorizedUserRelationship: postObj.AuthorizedUserRelationship,
      AuthorizedUserName: postObj.AuthorizedUserName,
      BillingAddressTypeID: 'Yes',
      BillingAddress: postObj.BillingAddress,
      BillingState: postObj.BillingState,
      BillingUnit: postObj.BillingUnit,
      BillingCity: postObj.BillingCity,
      BillingZipcode: postObj.BillingZipcode,
      AutoPay: autopay,
      AutopayType: '',
      AccountType: '',
      NameOnAccount: '',
      RoutingNumber: '',
      AccountNumber: '',
      CreditCardName: '',
      CreditCardNumber: '',
      CreditCardExpirationMonth: '',
      CreditCardExpirationYear: '',
      CreditCardCVC: '',
      CreditCardBillingAddressTypeID: '',
      CreditCardAddress: '',
      CreditCardState: '',
      CreditCardCity: '',
      CreditCardUnit: '',
      CreditCardZipcode: '',
      PayDeposit: paydeposit ? paydeposit : '',
      DepositCardNumber: DepositCardNumber ? DepositCardNumber : '',
      DepositCardExpirationMonth: DepositCardExpirationMonth
        ? DepositCardExpirationMonth
        : '',
      DepositCardExpirationYear: DepositCardExpirationYear
        ? DepositCardExpirationYear
        : '',
      DepositCVC: DepositCVC ? DepositCVC : '',
      DepositBillingAddress: DepositBillingAddress ? DepositBillingAddress : '',
      DepositUnit: DepositUnit ? DepositUnit : '',
      DepositState: DepositState ? DepositState : '',
      DepositZip: DepositZip ? DepositZip : '',
      DepositCity: DepositCity ? DepositCity : '',
      waivedReason: waivedReason ? waivedReason : '',
      SendViaEmail: emailorfax ? emailorfax : '',
      UserName: '',
      Password: '',
      ConfirmPassword: '',
      SecurityQuestion: '',
      SecurityAnswer: '',
    };
    
    var files__  = [];
    for (const file of this.listofFiles) {
      files__.push(file.Path)
     }
    // postObject['DepositWaiverFiles'] = files__;
     // for (var key in postObject) {
    //   formData.append(key, postObject[key]);
    // }

    // if (this.selectedFile != null) {
    //   // postObject['File'] = this.fileSelected;
    //   formData.append(
    //     "postObject['File']",
    //     this.listofFiles[0],
    //     this.listofFiles[0].name
    //   ); //your file, file name

    //   formData.append("postObject['File']", postObject['File']);
  //   for (const file of this.listofFiles) {
    //     formData.append('file', file, file.name); // file.name is optional
    //   }
    // }
    console.log('postObject: ', postObject);

    const user = {
      postObject: postObject,
      energyProvider: 'Chariot Energy',
      DepositWaiverFiles: files__
    };

    sessionStorage.setItem('PostObject', JSON.stringify(postObject));

    if (this.isuploadfile === true) {
      var postresult = [];
      this.residentialService
        .postApiOfEnrollmentUpload(user)
        .subscribe((res: any) => {
          this.onCloseHandled();
          var postresult = JSON.parse(res);
          
          if (
            postresult['Status'] &&
            postresult['Status'] === 'Validation Failed'
          ) {
            let postMessageResult = postresult['Message'];
            this.postResponseMessage = 'Input contains a non-ASCII character';
            this.postResponseMessage = postMessageResult;
            this.TrackFunction(postresult['Status'] + ": " +postresult['Message'],postObj.EmailAddress);
            this.residentialService.SendFailedEnrollment(this.residentialService.completeCustomerEnrollmentPostObject.orderDetails, res,res).subscribe((res: any) => {});
          } else if (
            postresult['Status'] &&
            postresult['Status'] != 'Validation Failed'
          ) {
            sessionStorage.setItem('postresult', JSON.stringify(postresult));
            let status = postresult['Status'];
            let message = postresult['Message'];
            this.TrackFunction(message,postObj.EmailAddress);
            if (
              status === 'Enrollment has been completed' ||
              status === 'Enrollment has been completed with Pending Status'
            ) {
              const hg_accountId = window.location.href.split('/').pop();

              var referenumber = postresult['RefrenceNumber'];
              sessionStorage.setItem('referenumber', referenumber);

              var reason;
              
              if (this.emailorfax === true) {
                reason = 'Waiting for Waiveoff Document Verification';
              } else {
                reason = 'Waiting to receive Waiveoff Document';
              }
              this.orderDetails = {
                referenumber: referenumber,
                hg_accountId: hg_accountId,
                isDepositRequired: 'null',
                webStatus:"Pending",
                  // this.Paythe$175deposit === true
                  //   ? 'Completed'
                  //   : 'Pending Deposit',
                reason: reason,
              };
              const postObjDetails = this.postObjDetails();
              this.orderDetails = {
                ...this.orderDetails,
                ...postObjDetails,
              };
              // this.residentialService.completeCustomerEnrollmentPostObject =
              //   this.orderDetails;

              this.orderDetails.reason = reason;

              this.residentialService.setConfirmationStatusDetails =
                this.orderDetails;
              const body = new HttpParams().append(
                'orderDetails',
                JSON.stringify(this.orderDetails)
              );
              this.http
                .post(this.url + '/saveorders', body)
                .subscribe((res: any) => {
                  const userId = JSON.parse(sessionStorage.getItem('userObj'));
                  const userObj = {
                    hg_accountId: postObjDetails.hg_accountId,
                    esiid: postObjDetails.esiid,
                    emailId: postObjDetails.contactInfo.emailId,
                    enableMessage: postObject.SendViaEmail,
                    referenumber: postObjDetails.ConfirmationNumber
                  
                  };

                  const body1 = new HttpParams()
                    .append('userDetails', JSON.stringify(userObj))
                    .append(
                      'providerContact',
                      JSON.stringify(this.providerContact)
                    );
                  this.http
                    .post(this.url + '/congratsEmail', body1)
                    .subscribe((res: any) => {
                      const result = res;
                      this.router.navigate(['congrats', hg_accountId]);
                    });
                  this.router.navigate(['congrats', hg_accountId]);
                });
            } else if (
              message === 'Required     Deposit Fields' ||
              message === 'Required Deposite Fields'
            ) {
              const hg_accountId = window.location.href.split('/').pop();
              this.router.navigate(['openwithdeposit', hg_accountId]);
            } else if (status === 'CreditCheck Failed') {
              const hg_accountId = window.location.href.split('/').pop();
              this.residentialService.SendFailedEnrollment(this.residentialService.completeCustomerEnrollmentPostObject.orderDetails, res,res).subscribe((res: any) => {});
              this.router.navigate(['creditcheck-furtheraction', hg_accountId]);
            } else {
              const hg_accountId = window.location.href.split('/').pop();
              this.router.navigate(['creditcheck-furtheraction', hg_accountId]);
            }
            if (
              postresult['Status'] === 'Enrollment has been completed' ||
              postresult['Status'] ===
                'Enrollment has been completed with Pending Status'
            ) {
              this.TrackFunction(postresult['Status'],postObj.EmailAddress );
              let referenumber = postresult['RefrenceNumber'];
              const hg_accountId = window.location.href.split('/').pop();
              this.orderDetails = {
                referenumber: referenumber,
                hg_accountId: hg_accountId,
                webStatus: 'Completed',
              };
              this.orderDetails = {
                ...this.orderDetails,
                ...this.postObjDetails(),
              };
              this.residentialService.setConfirmationStatusDetails =
                this.orderDetails;

              this.orderDetails.reason = reason;
              const body = new HttpParams().append(
                'orderDetails',
                JSON.stringify(this.orderDetails)
              );
              this.http
                .post(this.url + '/saveorders', body)
                .subscribe((res: any) => {
                  // console.log('updating orders Table');
                  const userObj = {
                    hg_accountId: window.location.href.split('/').pop(),
                    esiid: localStorage.getItem('currentEsiid'),
                    emailId: JSON.parse(sessionStorage.getItem('userObj'))
                      .emailId,
                    enableMessage: postObject.SendViaEmail,
                    referenumber: postresult['RefrenceNumber'],
                  };

                  const body1 = new HttpParams()
                    .append('userDetails', JSON.stringify(userObj))
                    .append(
                      'providerContact',
                      JSON.stringify(this.providerContact)
                    );
                  this.http
                    .post(this.url + '/congratsEmail', body1)
                    .subscribe((res: any) => {
                      //this.spinner.hide();
                      const result = res;
                    });
                });
            }
          }
        });
    }

    if (this.isuploadfile != true) {
      this.residentialService
        .postApiOfEnrollment(user)
        .subscribe((res: any) => {
          this.onCloseHandled();
          var postresult = JSON.parse(res);
          this.residentialService.enrollmentPostResult = postresult;

          // console.log('postresult.....', postresult);
          if (
            postresult['Status'] &&
            (postresult['Status'] === 'Validation Failed' ||
              postresult['Status'] === 'Deposit Failed')
          ) {
            let postMessageResult = postresult['Message'];
            this.postResponseMessage = postMessageResult;
              this.TrackFunction(postresult['Status'] + ": " + postresult['Message'], postObj.EmailAddress);
              this.residentialService.SendFailedEnrollment(this.residentialService.completeCustomerEnrollmentPostObject.orderDetails, res,res).subscribe((res: any) => { });
          } else if (
            postresult['Status'] &&
            postresult['Status'] != 'Validation Failed'
          ) {
            sessionStorage.setItem('postresult', JSON.stringify(postresult));
            let status = postresult['Status'];
            let message = postresult['Message'];
            this.TrackFunction(message,postObj.EmailAddress);
            if (
              status === 'Enrollment has been completed' ||
              status === 'Enrollment has been completed with Pending Status'
            ) {
              const hg_accountId = window.location.href.split('/').pop();

              var referenumber = postresult['RefrenceNumber'];
              sessionStorage.setItem('referenumber', referenumber);

              var reason;var webStatus;
              if (this.Paythe$175deposit === true) {
                reason = 'Deposit Paid';
                webStatus = "Completed"
              } else if (this.emailorfax === true) {
                reason = 'Waiting for Waiveoff Document Verification';
                webStatus = "Pending"
              } 

              this.orderDetails = {
                referenumber: referenumber,
                hg_accountId: hg_accountId,
                isDepositRequired: 'null',
                webStatus: webStatus,
                 
                reason: reason,
              };
              const postObjDetails = this.postObjDetails();
              this.orderDetails = {
                ...this.orderDetails,
                ...postObjDetails,
              };
              // this.residentialService.completeCustomerEnrollmentPostObject =
              //   this.orderDetails;
              this.residentialService.setConfirmationStatusDetails =
                this.orderDetails;

             this.orderDetails.reason = reason;
              const body = new HttpParams().append(
                'orderDetails',
                JSON.stringify(this.orderDetails)
              );
              this.http
                .post(this.url + '/saveorders', body)
                .subscribe((res: any) => {
                  const userId = JSON.parse(sessionStorage.getItem('userObj'));
                  const userObj = {
                    hg_accountId: postObjDetails.hg_accountId,
                    esiid: postObjDetails.esiid,
                    emailId: postObjDetails.contactInfo.emailId,
                    enableMessage: postObject.SendViaEmail,
                    referenumber: postObjDetails.ConfirmationNumber
                   
                  };

                  const body1 = new HttpParams()
                    .append('userDetails', JSON.stringify(userObj))
                    .append(
                      'providerContact',
                      JSON.stringify(this.providerContact)
                    );
                  this.http
                    .post(this.url + '/congratsEmail', body1)
                    .subscribe((res: any) => {
                      const result = res;
                    });
                  this.router.navigate(['congrats', hg_accountId]);
                });
            } else if (
              message === 'Required     Deposit Fields' ||
              message === 'Required Deposite Fields'
            ) {
              const hg_accountId = window.location.href.split('/').pop();
              this.router.navigate(['openwithdeposit', hg_accountId]);
            } else if (status === 'CreditCheck Failed') {
              const hg_accountId = window.location.href.split('/').pop();
                this.residentialService.SendFailedEnrollment(this.residentialService.completeCustomerEnrollmentPostObject.orderDetails, res,res).subscribe((res: any) => {});
              this.router.navigate(['creditcheck-furtheraction', hg_accountId]);
            } else {
              const hg_accountId = window.location.href.split('/').pop();
              this.router.navigate(['creditcheck-furtheraction', hg_accountId]);
            }
            if (
              postresult['Status'] === 'Enrollment has been completed' ||
              postresult['Status'] ===
                'Enrollment has been completed with Pending Status'
            ) {
            }
          }
        });
    }
  }

  onCloseHandled() {
    this.display = 'none';
  }
  assignConfirmationStatus(itemValue): string {
    return itemValue === 'Pending Deposit' || 'Pending Credit Check'
      ? itemValue
      : '';
  }
  getServiceTypeValues() {
    let serviceType, expiredDate, responses, switchObj, serviceTypeObj;

    if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
    {
    responses = JSON.parse(sessionStorage.getItem('userResponse'));
    this.userResponses = responses.userResponses;
    this.residentialService.userResponse['userResponses'] = this.userResponses;
    if (!_.isEmpty(this.userResponses)) {
      switchObj = _.findWhere(this.userResponses, {
        res_question_id: '002',
      });
      serviceType = switchObj.fieldValue;
      serviceTypeObj =
        this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
      expiredDate = this.expiratonDateFromQuestion();
    }
    return {
      serviceType: serviceType,
      switchType: serviceTypeObj.switchType,
      switchDate: serviceTypeObj.startDate,
      moveInType: serviceTypeObj.switchType,
      expiredDate: expiredDate,
    };
  }else
  {

    var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
    //this.userResponses = responses.userResponses;
    //this.residentialService.userResponse['userResponses'] = this.userResponses;
    if (!_.isEmpty(responses__)) {
      switchObj = _.findWhere(responses__, {
        res_question_id: '002',
      });
      serviceType = switchObj.fieldValue;
      serviceTypeObj =
        this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
      expiredDate = this.expiratonDateFromQuestion();
    }
    return {
      serviceType: serviceType,
      switchType: serviceTypeObj.switchType,
      switchDate: serviceTypeObj.startDate,
      moveInType: serviceTypeObj.switchType,
      expiredDate: expiredDate,
    };
  }
  }
  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }
  expiratonDateFromQuestion() {
    let expiredDate;
    const expireObj = _.findWhere(this.userResponses, {
      res_question_id: '003',
    });
    if (!_.isEmpty(expireObj) && typeof expireObj.fieldValue !== 'string') {
      const date = JSON.parse(expireObj.fieldValue.date);
      expiredDate = this.getServiceTypeDateObj(date);
    } else if (
      !_.isEmpty(expireObj) &&
      typeof expireObj.fieldValue === 'string'
    ) {
      expiredDate = expireObj.fieldValue;
    }
    return expiredDate !== undefined ? expiredDate : '';
  }
  assignServiceTypeValuesForStandardSwitch(): any {

    if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
    {


    const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
    let startDate,
      switchType = obj.fieldValue;
    if (switchType === 'Standard Switch') {
      startDate = 'Standard Switch';
    } else {
      const dateObj = _.findWhere(this.userResponses, {
        res_question_id: '005',
      });
      startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
    }
    return { switchType: switchType, startDate: startDate };
  }
  else
  {
    var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
    const obj = _.findWhere(responses__, { res_question_id: '004' });
    let startDate,
      switchType = obj.fieldValue;
    if (switchType === 'Standard Switch') {
      startDate = 'Standard Switch';
    } else {
      const dateObj = _.findWhere(responses__, {
        res_question_id: '005',
      });
      startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
    }
    return { switchType: switchType, startDate: startDate };
  }
}
  assignServiceTypeValuesForNewService() {

    if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
    {


    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
    return { switchType: switchType, startDate: startDate };
  } else
  {
    var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
   
    const switchDateObj = _.findWhere(responses__, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
    return { switchType: switchType, startDate: startDate };

  }
  }
  getServiceTypeDateObj(dateObj) {
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? new Date(dateObj).getFullYear() +
          '-' +
          this.pad(new Date(dateObj).getMonth() + 1) +
          '-' +
          new Date(dateObj).getDate()
      : this.pad(new Date(dateObj).getMonth() + 1) +
          '/' +
          new Date(dateObj).getDate() +
          '/' +
          new Date(dateObj).getFullYear();
  }
  serviceTypeExpireDate(startDate) {
    let term = this.recommendationService.signupProduct.terms,
      expiredDate =
        startDate !== 'Priority Move-In' && startDate !== 'Standard Switch'
          ? new Date(startDate)
          : new Date();
    expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
    return this.suffixDateTimeToSelectedSwitchDate(expiredDate);
  }
  suffixDateTimeToSelectedSwitchDate(expiredDate) {
    var d = new Date(expiredDate);
    return this.selectedProduct.energy_provider === '4Change Energy'
      ? d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + d.getDate()
      : [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
          ' ' +
          [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':');
  }

  getPrimaryPhoneNumber() {
    return this.residentialService.completeCustomerEnrollmentPostObject
      .orderDetails.contactInfo.phoneNo
      ? this.residentialService.completeCustomerEnrollmentPostObject.orderDetails.contactInfo.phoneNo.split(
          '-'
        )
      : '';
  }
  postObjDetails() {
    let serviceTypeDateDetails = this.getServiceTypeValues();
    this.residentialService.completeCustomerEnrollmentPostObject =
      this.orderDetails;
    const postObjDetails = JSON.parse(
      sessionStorage.getItem('chariotPostObject')
    );

    const userId = JSON.parse(sessionStorage.getItem('userObj'));
    const orderDetails = {
      order_no: null,
      hg_accountId: userId._id,
      ConfirmationNumber: this.orderDetails.referenumber,
      status: this.orderDetails.webStatus,
      isDepositRequired: this.assignConfirmationStatus(
        this.orderDetails.webStatus
      ),
      webStatus: this.orderDetails.webStatus,
      reason: this.orderDetails.webStatus,
      creditCheckResults: this.assignConfirmationStatus(
        this.orderDetails.webStatus
      ),
      customerId: this.orderDetails.referenumber,
      enableSMSForHonest: this.enablesmshonest === false ? 'No' : 'Yes',
      enableSMSForChariot: this.enablesmschariot === true ? 'Yes' : 'No',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: postObjDetails.FirstName,
        legalLastName: postObjDetails.LastName,
        emailId: postObjDetails.EmailAddress,
        phoneNo: postObjDetails.PhoneNumber,
        language: postObjDetails.languagePreference,
        dob: postObjDetails.DOB,
        authorizedRep: postObjDetails.AuthorizedUserName,
      },
      esiid: postObjDetails.ESIID,
      invoiceType: postObjDetails.BillDeliverMethodID,
      promoDetails: {
        hearusOption: postObjDetails.Howdidyouhear,
        promoeCode: this.promo_code,
      },
      privateDetails: {
        state: postObjDetails.BillingState,
        license: postObjDetails.DriversLicence,
      },
      billingAddress: JSON.parse(sessionStorage.getItem('billingAddress')),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')

    };
    return orderDetails;
  }

  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    // append to head of document
    
    document.getElementsByTagName('head')[0].appendChild(node); 
  
    let script = this._renderer2.createElement('script');
    script.setAttribute('id', 'ChatScript');
    script.text = `
        (function(d, w, c) {
          w.BrevoConversationsID = '649dacacdbc74231a94a3297';
          w[c] = w[c] || function() {
              (w[c].q = w[c].q || []).push(arguments);
          };
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
          if (d.head) d.head.appendChild(s);
      })(document, window, 'BrevoConversations');
    `;
  
    const existingScript = document.getElementById("ChatScript");
    if (!existingScript) {
      
    document.getElementsByTagName('head')[0].appendChild(script); 
    }
  }

TrackFunction(Status,Email)
{
  
  var product = this.selectedProduct
  var value = sessionStorage.getItem('esiidValue')
  var subString = value != null ? value.substring(value.length - 5) : "";

  CallTrack_function(
    "EnrollmentSubmit",
    product.energy_provider, 
    product.product_key, 
    product.terms, 
    (product.tier[0].avg_charge * 100).toFixed(1),
    (product.tier[1].avg_charge * 100).toFixed(1),
    (product.tier[2].avg_charge * 100).toFixed(1),
    subString,  
    product.utility_name, 
    Status,Email );

}

}

